import { SportsListType } from 'src/AppState/sdk/staff';
import { jsonParse } from 'src_common/common/jsonParse';
import { z } from 'zod';

export const FIRST_PAGE = 1;
export const PER_PAGE = 200;

export interface TreeType {
    id: string;
    value: string;
    label: React.ReactNode;
    name: string;
    children?: TreeType[];
}

export const nodeValueZodSchema = z.union([
    z.object({
        type: z.literal('sport'),
        sportId: z.string(),
    }),
    z.object({
        type: z.literal('competition'),
        sportId: z.string(),
        competitionId: z.string(),
        name: z.string().optional(),
    }),
]);

export type NodeValueType = z.infer<typeof nodeValueZodSchema>;

export const serializeNodeValue = (value: NodeValueType): string => {
    return JSON.stringify(value);
};

export const deserializeNodeValue = (serializedValue: string): NodeValueType | null => {
    const deserialized = jsonParse(serializedValue);

    if (deserialized.type === 'text') {
        console.warn('deserializeNodeValue -> json parse error for value: ', deserialized);
        return null;
    }

    const parsed = nodeValueZodSchema.safeParse(deserialized.json);

    if (parsed.success === false) {
        console.warn('deserializeNodeValue -> ', parsed.error);
        return null;
    }

    return parsed.data;
};

export const flattenSport = (sports: SportsListType): { sportId: string; name: string }[] => {
    const flattenedItems = sports.map((item) => {
        return {
            sportId: item.id,
            name: item.name,
        };
    });

    return flattenedItems;
};

export const sortSportsAlphabetically = (
    sports: { sportId: string; name: string }[]
): { sportId: string; name: string }[] => {
    const sortedItems = sports.sort((a, b) => {
        const aValue = a.name;
        const bValue = b.name;

        if (aValue > bValue) {
            return 1;
        }
        if (aValue < bValue) {
            return -1;
        }
        return 0;
    });
    return sortedItems;
};
